// extracted by mini-css-extract-plugin
export var teamNames = "TeamNames-module--teamNames--8364d";
export var vs = "TeamNames-module--vs--60f73";